module.exports = __webpack_public_path__ + "img/黄芩.b6d8167a.jpg";